"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
/** @ignore */
exports.messages = {
    serverUrlNotSet: 'Server URL not set.  Call init function',
    serverError: 'Unable to communicate with HTTP Gateway server',
    serverNotVerified: 'The HTTP Gateway server has not been verified. Run test or init first',
    downloadFailed: 'The download failed to initiate',
    streamFailed: 'The stream failed to initiate',
    notValidTransferSpec: 'The supplied transferSpec is not valid',
    invalidServerUrl: 'The supplied server URL is invalid',
    unableToGetFilesForUpload: 'Unable to get files for upload based on transferSpec',
    unableToUpload: 'Unable to upload. Server encountered an error',
    failedToGetDownloadUrl: 'Unable to retrieve HTTP download URL',
    failedToGetStreamUrl: 'Unable to retrieve HTTP stream URL',
    streamInjectDomInvalid: 'Unable to find injection point for video player',
    failedToGenerateIframe: 'Unable to generate IFRAME for download. Using new window',
    callbackIsNotFunction: 'The provided callback is not a function',
    websocketClosedUnexpect: 'The websocket was closed unexpectedly',
    invalidChunkSize: 'The provided chunk size for uploads is invalid',
    invalidConcurrentUploads: 'The provided number for concurrent uploads is invalid',
    unableToParseDataForUpload: 'Unable to parse data for uploading',
    unableToDeepCopyObject: 'Unable to deep copy object or array',
    unableToFindElementOnPage: 'Unable to find the element on the current page',
    unauthorizedFilesForUpload: 'Unauthorized files included in the transferSpec. All files for upload must be picked via getFilesForUpload',
    startDownload: 'Start HTTP download?',
    dropFoldersNotAllowed: 'Dropping folders is not currently allowed',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    leavingWhileUploading: 'An upload is in progress. If you leave the upload will be cancelled.',
    unableToReadFolder: 'The dropped item could not be parsed. Please try selecting via the select file/folder option',
    streamingTooManyFiles: 'Too many files requested for a stream. Only one video file is allowed in the transferSpec',
    loadingDownload: 'The download will now open in this window.',
    versionNotsupported: 'This SDK only supports v2 and below. For newer IBM Aspera HTTP Gateway you must use @ibm-aspera/sdk package. Learn more: https://github.com/IBM/aspera-sdk-js.',
    deprecationWarning: 'This SDK is deprecated. Move to @ibm-aspera/sdk package to support future IBM Aspera Gateway versions. Learn more: https://github.com/IBM/aspera-sdk-js.',
};
